/* eslint-disable css-modules/no-unused-class, prefer-template */
import styles from './preloadSvg.module.scss';

const PreloadSvgs = () => {
    const svgClassNames = [
        'login-wrapper',
        'cb-logo',
        'test',
        'noMatchingResults',
        'assessment-result-empty-state-title',
        'tournament-banner',
        'learn',
        'play',
        'certificate-wrapper'
    ];

    const images = [
        `${process.env.PUBLIC_URL}/images/courseTopIcon.svg`,
        `${process.env.PUBLIC_URL}/images/lessonTopIcon.svg`,
        `${process.env.PUBLIC_URL}/images/challengeTopIcon.svg`,
        `${process.env.PUBLIC_URL}/images/assessmentTopIcon.svg`,
        `${process.env.PUBLIC_URL}/images/course.webp`,
        `${process.env.PUBLIC_URL}/images/lessonOuterRight.svg`,
        `${process.env.PUBLIC_URL}/images/lessonOuterLeft.svg`,
        `${process.env.PUBLIC_URL}/images/mixTop.svg`,
        `${process.env.PUBLIC_URL}/images/mixed.svg`,
        `${process.env.PUBLIC_URL}/images/courseOuterRight.svg`,
        `${process.env.PUBLIC_URL}/images/courseOuterLeft.svg`,
        `${process.env.PUBLIC_URL}/images/courseElement.webp`,
        `${process.env.PUBLIC_URL}/images/lessonElement.png`,
        `${process.env.PUBLIC_URL}/images/startPath.svg`,
        `${process.env.PUBLIC_URL}/images/courseSmallIcon.svg`,
        `${process.env.PUBLIC_URL}/images/lessonSmallIcon.svg`,
        `${process.env.PUBLIC_URL}/images/challengeSmallIcon.svg`,
        `${process.env.PUBLIC_URL}/images/assessmentSmallIcon.svg`
    ];

    const cssImages = [
        `${process.env.PUBLIC_URL}/images/lesson.webp`,
        `${process.env.PUBLIC_URL}/images/course.webp`,
        `${process.env.PUBLIC_URL}/images/assessment.svg`,
        `${process.env.PUBLIC_URL}/images/challenge.svg`,
        `${process.env.PUBLIC_URL}/images/mixed.svg`
    ];

    return (
        <div data-testid="svg-preload">
            <>
                {svgClassNames.map(svgClassName => (
                    <div key={svgClassName} className={styles[svgClassName]} />
                ))}
            </>
            <div style={{ display: 'none' }}>
                {images.map(image => (
                    <img style={{ display: 'none' }} key={image} src={image} alt="svgImage" loading="lazy" />
                ))}
            </div>
            <div style={{ display: 'none' }}>
                {cssImages.map(image => (
                    <div style={{ '--img': 'url(' + image + ')' } as any} key={image} />
                ))}
            </div>
        </div>
    );
};

export default PreloadSvgs;
